import { defineStore } from "pinia";

export const courseStore = defineStore("course", {
  state: () => ({
    // 当前播放的课程详情
    courseInfo: {},
    // 目录距离页面顶部高度
    menuTop: 0,
    // 是否固定目录
    menuFixed: false,
    // 是否有音频在播放
    isPlaying: false,
  }),
  getters: {
    getCourseInfo: (state) => {
      if (JSON.stringify(state.courseInfo) === "{}") {
        const info = localStorage.getItem("courseInfo");
        return JSON.parse(info);
      } else {
        return state.courseInfo;
      }
    },
    getMenuTop: (state) => state.menuTop,
    getMenuFixed: (state) => state.menuFixed,
    getIsPlaying: (state) => state.isPlaying,
  },
  actions: {
    setCourseInfo(courseInfo) {
      this.courseInfo = courseInfo;
    },
    setMenuTop(menuTop) {
      this.menuTop = menuTop;
    },
    setMenuFixed(menuFixed) {
      this.menuFixed = menuFixed;
    },
    setIsPlaying(isPlaying) {
      this.isPlaying = isPlaying;
    },
  },
});
